import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import EventCreation from "./pages/EventCreation";
import Login from "./pages/RegLogin";
import MasterLogin from "./pages/Login";
import Navbar from "./components/Navbar";
import Cookies from "js-cookie";
import InformationModal from "./components/InformationModal";
import EventHandle from "./pages/EventHandle";
import MasterDashboard from "./pages/MasterDashboard";
import ZoneRegionManager from "./pages/ZoneRegionManager";
import VehicleSelectionEventCreation from "./pages/VehicleSelectionEventCreation"; 

const ProtectedRoute = ({ element }) => {
  const [isCookieReady, setIsCookieReady] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const location = useLocation();
  const maxRetries = 10;

  useEffect(() => {
    let timeoutId;
    let retryCount = 0;

    const checkCookies = () => {
      const isAuthenticatedFromCookie = Cookies.get('adminAuthStatus') === 'true';

      if (isAuthenticatedFromCookie !== undefined) {
        setIsAuthenticated(isAuthenticatedFromCookie);
        setIsCookieReady(true);
      } else if (retryCount < maxRetries) {
        timeoutId = setTimeout(() => {
          retryCount++;
          checkCookies();
        }, 100);
      } else {
        console.error("Max retries reached. Cookies not available.");
        setIsCookieReady(true);
        setShowModal(true);
      }
    };

    // Reset state variables
    setIsCookieReady(false);
    setIsAuthenticated(false);
    setShowModal(false);
    setShouldRedirect(false);

    checkCookies();

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [location]);

  const handleCloseModal = () => {
    setShowModal(false);
    setShouldRedirect(true);
  };

  if (!isCookieReady) {
    return (
      <div
        style={{
          zIndex: "9999",
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          position: "fixed",
          top: 0,
          left: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div className="container-loading">
          <img
            className="vvendu-loading"
            src="https://admin.vvendu.com/logoInitialsTransparent.png"
            width="100"
            alt="Loading"
          />
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (shouldRedirect) {
    console.log("Redirecting to login after modal close");
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (showModal) {
    return (
      <InformationModal
        isOpen={showModal}
        onClose={handleCloseModal}
        message="Your session was invalidated."
      />
    );
  }

  if (!isAuthenticated) {
    console.log("Preparing to show modal due to invalid or missing auth status");
    setShowModal(true);
    return null;
  }

  return element;
};

const AppContent = () => {
  const location = useLocation();

  return (
    <div className="w-100 bg-white" style={{maxHeight:"95vh"}}>
      {(location.pathname !== "/" && location.pathname !== "/masterLogin") && <Navbar />}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/masterLogin" element={<MasterLogin />} />
        {/* Protected Routes */}
        <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
        <Route path="/ZoneRegionManager"element={<ProtectedRoute element={<ZoneRegionManager />}/>}/>
        <Route path="/eventCreation" element={<ProtectedRoute element={<EventCreation />} />}/>
        <Route path="/lenderEvent" element={<ProtectedRoute element={<EventHandle />} />}/>
        <Route path="/master-dashboard" element={<ProtectedRoute element={<MasterDashboard />} />}/>
        <Route path="/vehicleSelectionEventCreation" element={<ProtectedRoute element={<VehicleSelectionEventCreation/>}/>} />
      </Routes>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <link
        href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css"
        rel="stylesheet"
      />
      <AppContent />
    </Router>
  );
};

export default App;
